import axios from 'axios';
import Echo from 'laravel-echo'
import Pusher from 'pusher-js'


declare global {
    interface Window {
        Echo: any
        Pusher: any
    }
}




window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.Pusher = Pusher;
console.log('socket', import.meta.env.VITE_PUSHER_HOST + ":" +import.meta.env.VITE_PUSHER_PORT)


window.Echo = new Echo({
    broadcaster: 'pusher',
    key: import.meta.env.VITE_PUSHER_APP_KEY,
    cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER ?? 'mt1',
    wsHost: import.meta.env.VITE_PUSHER_HOST ? import.meta.env.VITE_PUSHER_HOST : `ws-${import.meta.env.VITE_PUSHER_APP_CLUSTER}.pusher.com`,
    wsPort: import.meta.env.VITE_PUSHER_PORT ?? 6002,
    wssPort: import.meta.env.VITE_PUSHER_PORT ?? 6002,
    forceTLS: (import.meta.env.VITE_PUSHER_SCHEME ?? 'https') === 'https',
    enabledTransports: ['ws', 'wss'],
})